import React, { useState } from "react";
import styles from "./styles/request-voice-modal.module.scss";
import StyledButton from "@/components/common/styled-button";
import StyledInput from "@/components/common/input/styled-input";
import {
  showRequestVoiceNotificationFailed,
  showRequestVoiceNotificationSent,
} from "@/utils/notification-helper";
import { ToastContainer } from "react-toastify";
import { useCurrentUser } from "@/hooks/use-current-user";

const RequestVoiceModal = () => {
  const [voiceRequest, setVoiceRequest] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const user = useCurrentUser();

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await fetch("/api/request-voice", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ voiceRequest, email: user?.email }),
      });
      if (response.ok) {
        showRequestVoiceNotificationSent();
        setVoiceRequest("");
      } else {
        showRequestVoiceNotificationFailed();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.text}>
            What voice would you like us to add?
          </div>
          <StyledInput
            value={voiceRequest}
            isValid
            placeholder={"Enter the voice you are interested in"}
            onChange={(e) => setVoiceRequest(e.target.value)}
          />
          <StyledButton
            title={"send"}
            onClick={handleSubmit}
            isLoading={isLoading}
          />
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default RequestVoiceModal;
